import { useSelector } from 'react-redux';

import { redeemedCodeSelector, shoppingCartSelector } from '~screens/Dashboard/screens/Home/redux/selectors';
import { TIP_ALLOWED } from '~constants/environment';
import { DISPATCH_METHODS } from '~constants/address';
import { PAYMENT_METHODS_ONLINE } from '~constants/paymentMethods';
import { onlyGiftCards } from '~models/shoppingCart';
import {
  disableForCouponUsage,
  disableTipsForGitfCardUsage,
  externalDeliveryCompanyAcceptTips
} from '~models/tips';

const useTipSelection = ({ selectedPaymentMethod, isPapaCar, dispatchMethod }) => {
  const { useGiftCard } = useSelector(redeemedCodeSelector);
  const shoppingCart = useSelector(shoppingCartSelector);
  const currentSubsidiary = useSelector(state => state.searchStore?.currentSubsidiary);
  const { items, total } = shoppingCart;
  const disableTips =
    disableTipsForGitfCardUsage(total, useGiftCard) ||
    disableForCouponUsage(shoppingCart) ||
    (currentSubsidiary &&
      !externalDeliveryCompanyAcceptTips(
        currentSubsidiary.externalDelivery,
        currentSubsidiary.externalDeliveryCompany
      ));
  const showTipModule =
    TIP_ALLOWED &&
    PAYMENT_METHODS_ONLINE[selectedPaymentMethod] &&
    dispatchMethod === DISPATCH_METHODS.PJ_DELIVERY &&
    !isPapaCar &&
    !onlyGiftCards(items) &&
    !disableTips;

  return { showTipModule, disableTips };
};

export default useTipSelection;
